import { supabase } from '@/integrations/supabase/client';

export async function getVendorProducts(vendorUserId: string) {
  const { data, error } = await supabase
    .from('products')
    .select('*')
    .eq('vendor_id', vendorUserId)
    .order('created_at', { ascending: false });
  
  if (error) throw error;
  return data;
}

export async function getProductById(productId: string) {
  const { data, error } = await supabase
    .from('products')
    .select('*')
    .eq('id', productId)
    .single();
  
  if (error) throw error;
  return data;
}

export async function saveDraftChanges(productId: string, draftData: any) {
  const { error } = await supabase
    .from('products')
    .update({ draft_data: draftData })
    .eq('id', productId);
  
  if (error) throw error;
}

export async function submitForReview(productId: string) {
  const { error } = await supabase
    .from('products')
    .update({ status: 'updates_in_progress' })
    .eq('id', productId);
  
  if (error) throw error;
}
